import React from "react";
import TextField from "@mui/material/TextField";
import {formTextFieldStyle} from "./formTextFieldStyle";
import type {InputBaseComponentProps} from "@mui/material/InputBase";
import type {FilledInputProps} from "@mui/material/FilledInput";
import type {OutlinedInputProps} from "@mui/material/OutlinedInput";
import type {InputProps} from "@mui/material/Input";
import type {InputLabelProps} from "@mui/material/InputLabel";

interface FormInputProps {
  disabled?: boolean;
  id?: string;
  name: string;
  label?: string;
  setValue?: React.Dispatch<React.SetStateAction<number | string>>;
  error?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
  onCut?: (e: any) => void;
  onCopy?: (e: any) => void;
  onPaste?: (e: any) => void;
  value?: string;
  fullWidth?: boolean;
  required?: boolean;
  size?: "medium" | "small";
  type?: string; // "password"
  autoComplete?: string;
  helperText?: string;
  inputProps?: InputBaseComponentProps | undefined;
  InputProps?:
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>
    | Partial<InputProps>
    | undefined;
  inputRef?: any;
  autoFocus?: boolean;
  InputLabelProps?: Partial<InputLabelProps> | undefined;
  multiline?: boolean;
  placeholder?: string;
  rows?: number;
}

export const FormTextField = ({
  disabled,
  id,
  name,
  label,
  type,
  required,
  error,
  onChange,
  onCut,
  onCopy,
  onPaste,
  value,
  autoComplete,
  helperText,
  inputProps,
  InputProps,
  inputRef,
  autoFocus,
  size,
  InputLabelProps,
  multiline,
  placeholder,
  rows,
}: FormInputProps) => {
  return (
    <>
      <TextField
        className="input-font-family"
        disabled={disabled}
        helperText={helperText}
        id={id}
        name={name}
        error={!!error}
        onChange={onChange}
        onCut={onCut}
        onCopy={onCopy}
        onPaste={onPaste}
        value={value}
        type={type}
        fullWidth
        required={required}
        label={label}
        autoComplete={autoComplete}
        sx={formTextFieldStyle.loginmuiTextFieldStyle}
        inputProps={inputProps}
        InputProps={InputProps}
        inputRef={inputRef}
        autoFocus={autoFocus}
        size={size}
        InputLabelProps={InputLabelProps}
        multiline={multiline}
        placeholder={placeholder}
        rows={rows}
      />
    </>
  );
};
